import type { AxiosError, AxiosInstance, AxiosResponse } from "axios"
import type { IChangePasswordClient } from "../data/data-sources/i-change-password-client"
import type { ChangePasswordRequest } from "../domain/models/change-password"
import type { ApiResponse, AxiosDataResponse } from "../../../config/api-types"
import { USER_ENDPOINTS } from "../../../config/endpoints"


export class ChangePasswordService implements IChangePasswordClient {
  constructor(private readonly axios: AxiosInstance) {}

  async create(params: ChangePasswordRequest, jwtToken?: string): Promise<ApiResponse> {
    try {
      const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {}
      
      const result: AxiosResponse<AxiosDataResponse> = await this.axios.post(
        USER_ENDPOINTS.changePassword,
        params,
        { headers }
      )

      return {
        success: result.data.success,
        message: result.data.message,
        status: result.status,
      }
    } catch (error: any) {
      const axiosError = error as AxiosError<AxiosDataResponse>
      return {
        success: false,
        message: axiosError.response?.data?.message,
        status: axiosError.response?.status!,
      }
    }
  }
}
